import React, { useMemo, useState } from "react";
import { useCphDataContext } from "../../hooks/useCphDataContext";
import { useCphContext } from "../../hooks/useCphContext";
import { Card, CardContent, Typography, Stack, Box, Button } from "@mui/material";
import CommentCard from "./CommentCard";
import { CphResource } from "../../resources/CphResource";

const CommentCollectionCard: React.FC = () => {
    const { selectedIssue } = useCphDataContext();
    const { isStaff } = useCphContext();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

    const comments = Array.isArray(selectedIssue.comments) ? selectedIssue.comments : [];
    const visibleComments = comments.filter((comment) => isStaff || Number(comment.staffOnlyFlag) === 0);

    const [sortType, setSortType] = useState<'newest' | 'oldest'>('newest');

    const sortedCommentsList = useMemo(() => {
        const commentsCopy = [...visibleComments];
        switch (sortType) {
            case 'newest':
                return commentsCopy.sort((a, b) => {
                    const dateA = new Date(a.commentDate || 0).getTime();
                    const dateB = new Date(b.commentDate || 0).getTime();
                    return dateB - dateA;
                });
            case 'oldest':
                return commentsCopy.sort((a, b) => {
                    const dateA = new Date(a.commentDate || 0).getTime();
                    const dateB = new Date(b.commentDate || 0).getTime();
                    return dateA - dateB;
                });
            default:
                return commentsCopy;
        }
    }, [visibleComments, sortType]);

    return (
        <Card sx={{ width: '100%', height: '100%', maxWidth: '100%', mx: 0, px: 0, py: 0 }}>
            <CardContent>
                {visibleComments.length === 0 ? (
                    <Typography variant="body2">{CphResource.no_comments_lbl}</Typography>
                ) : (
                    <Box paddingTop={3}>
                        <Stack direction="row" spacing={2}>
                            <Button variant={sortType === 'newest' ? 'contained' : 'text'} size="small" onClick={() => setSortType('newest')}>
                                Newest
                            </Button>
                            <Button variant={sortType === 'oldest' ? 'contained' : 'text'} size="small" onClick={() => setSortType('oldest')}>
                                Oldest
                            </Button>
                        </Stack>
                        {sortedCommentsList.map((comment, idx) => (
                            <CommentCard key={comment.commentKey || idx} comment={comment} />
                        ))}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default CommentCollectionCard;
